import { SettingItem } from './index.d';


export const settingList: SettingItem[] = [
  {
    value: false,
    title: '自定义安全守护',
    desc: '孩子进出守护区域，家长收到通知'
  }
]